import { render, staticRenderFns } from "./estimated_cost_detail.vue?vue&type=template&id=bb333936&scoped=true"
import script from "./estimated_cost_detail.vue?vue&type=script&lang=js"
export * from "./estimated_cost_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb333936",
  null
  
)

export default component.exports